"use strict";

var __extends = function () {
  var _n = function n(t, e) {
    return (_n = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (t, e) {
      t.__proto__ = e;
    } || function (t, e) {
      for (var i in e) {
        e.hasOwnProperty(i) && (t[i] = e[i]);
      }
    })(t, e);
  };

  return function (t, e) {
    function i() {
      this.constructor = t;
    }

    _n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i());
  };
}(),
    _assign = function __assign() {
  return (_assign = Object.assign || function (t) {
    for (var e, i = 1, n = arguments.length; i < n; i++) {
      for (var o in e = arguments[i]) {
        Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    __createBinding = Object.create ? function (t, e, i, n) {
  void 0 === n && (n = i), Object.defineProperty(t, n, {
    enumerable: !0,
    get: function get() {
      return e[i];
    }
  });
} : function (t, e, i, n) {
  void 0 === n && (n = i), t[n] = e[i];
},
    __setModuleDefault = Object.create ? function (t, e) {
  Object.defineProperty(t, "default", {
    enumerable: !0,
    value: e
  });
} : function (t, e) {
  t.default = e;
},
    __importStar = function __importStar(t) {
  if (t && t.__esModule) return t;
  var e = {};
  if (null != t) for (var i in t) {
    "default" !== i && Object.hasOwnProperty.call(t, i) && __createBinding(e, t, i);
  }
  return __setModuleDefault(e, t), e;
},
    __awaiter = function __awaiter(t, a, r, l) {
  return new (r = r || Promise)(function (i, e) {
    function n(t) {
      try {
        s(l.next(t));
      } catch (t) {
        e(t);
      }
    }

    function o(t) {
      try {
        s(l.throw(t));
      } catch (t) {
        e(t);
      }
    }

    function s(t) {
      var e;
      t.done ? i(t.value) : ((e = t.value) instanceof r ? e : new r(function (t) {
        t(e);
      })).then(n, o);
    }

    s((l = l.apply(t, a || [])).next());
  });
},
    __generator = function __generator(i, n) {
  var o,
      s,
      a,
      r = {
    label: 0,
    sent: function sent() {
      if (1 & a[0]) throw a[1];
      return a[1];
    },
    trys: [],
    ops: []
  },
      t = {
    next: e(0),
    throw: e(1),
    return: e(2)
  };
  return "function" == typeof Symbol && (t[Symbol.iterator] = function () {
    return this;
  }), t;

  function e(e) {
    return function (t) {
      return function (e) {
        if (o) throw new TypeError("Generator is already executing.");

        for (; r;) {
          try {
            if (o = 1, s && (a = 2 & e[0] ? s.return : e[0] ? s.throw || ((a = s.return) && a.call(s), 0) : s.next) && !(a = a.call(s, e[1])).done) return a;

            switch (s = 0, a && (e = [2 & e[0], a.value]), e[0]) {
              case 0:
              case 1:
                a = e;
                break;

              case 4:
                return r.label++, {
                  value: e[1],
                  done: !1
                };

              case 5:
                r.label++, s = e[1], e = [0];
                continue;

              case 7:
                e = r.ops.pop(), r.trys.pop();
                continue;

              default:
                if (!(a = 0 < (a = r.trys).length && a[a.length - 1]) && (6 === e[0] || 2 === e[0])) {
                  r = 0;
                  continue;
                }

                if (3 === e[0] && (!a || e[1] > a[0] && e[1] < a[3])) {
                  r.label = e[1];
                  break;
                }

                if (6 === e[0] && r.label < a[1]) {
                  r.label = a[1], a = e;
                  break;
                }

                if (a && r.label < a[2]) {
                  r.label = a[2], r.ops.push(e);
                  break;
                }

                a[2] && r.ops.pop(), r.trys.pop();
                continue;
            }

            e = n.call(i, r);
          } catch (t) {
            e = [6, t], s = 0;
          } finally {
            o = a = 0;
          }
        }

        if (5 & e[0]) throw e[1];
        return {
          value: e[0] ? e[1] : void 0,
          done: !0
        };
      }([e, t]);
    };
  }
},
    __importDefault = function __importDefault(t) {
  return t && t.__esModule ? t : {
    default: t
  };
};

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var react_1 = __importDefault(require("react")),
    vanilla_swipe_1 = __importDefault(require("vanilla-swipe")),
    defaultProps_1 = require("./defaultProps"),
    types_1 = require("./types"),
    Views = __importStar(require("./views")),
    Utils = __importStar(require("./utils")),
    AliceCarousel = function (i) {
  function t(t) {
    var o = i.call(this, t) || this;
    o.swipeListener = null, o._handleBeforeSlideEnd = function () {
      return __awaiter(o, void 0, void 0, function () {
        var e, i, n;
        return __generator(this, function (t) {
          switch (t.label) {
            case 0:
              return (i = this.state, e = i.activeIndex, n = i.itemsCount, i = i.fadeoutAnimationProcessing, Utils.shouldRecalculateSlideIndex(e, n)) ? (n = Utils.getUpdateSlidePositionIndex(e, n), [4, this._handleUpdateSlidePosition(n)]) : [3, 2];

            case 1:
              return t.sent(), [3, 4];

            case 2:
              return i ? [4, this.setState({
                fadeoutAnimationIndex: null,
                fadeoutAnimationPosition: null,
                fadeoutAnimationProcessing: !1
              })] : [3, 4];

            case 3:
              t.sent(), t.label = 4;

            case 4:
              return this._handleSlideChanged(), [2];
          }
        });
      });
    }, o._handleMouseEnter = function () {
      var t = o.props.autoPlayStrategy;
      Utils.shouldCancelAutoPlayOnHover(t) && o.state.isAutoPlaying && (o.isHovered = !0, o._handlePause());
    }, o._handleMouseLeave = function () {
      o.state.isAutoPlaying && (o.isHovered = !1, o._handlePlay());
    }, o._handlePause = function () {
      o._clearAutoPlayTimeout();
    }, o._handlePlayPauseToggle = function () {
      return __awaiter(o, void 0, void 0, function () {
        var e;
        return __generator(this, function (t) {
          switch (t.label) {
            case 0:
              return e = this.state.isAutoPlaying, this.hasUserAction = !0, [4, this.setState({
                isAutoPlaying: !e,
                isAutoPlayCanceledOnAction: !0
              })];

            case 1:
              return t.sent(), e ? this._handlePause() : this._handlePlay(), [2];
          }
        });
      });
    }, o._setRootComponentRef = function (t) {
      return o.RootElement = t;
    }, o._setStageComponentRef = function (t) {
      return o.stageComponent = t;
    }, o._renderStageItem = function (t, e) {
      var i = Utils.getRenderStageItemStyles(e, o.state),
          n = Utils.getRenderStageItemClasses(e, o.state);
      return react_1.default.createElement(Views.StageItem, {
        styles: i,
        className: n,
        key: "stage-item-" + e,
        item: t
      });
    }, o._renderSlideInfo = function () {
      var t = o.props.renderSlideInfo,
          e = o.state,
          i = e.activeIndex,
          e = e.itemsCount;
      return react_1.default.createElement(Views.SlideInfo, {
        itemsCount: e,
        activeIndex: i,
        renderSlideInfo: t
      });
    };
    var e = Utils.getItemsCount(t),
        t = Utils.createClones(t);
    return o.state = {
      activeIndex: 0,
      animationDuration: 0,
      autoWidth: !1,
      clones: t,
      itemsCount: e,
      itemsOffset: 0,
      itemsInSlide: 1,
      infinite: !1,
      initialStageHeight: 0,
      isAutoPlaying: !1,
      isAutoPlayCanceledOnAction: !1,
      isStageContentPartial: !0,
      fadeoutAnimationIndex: null,
      fadeoutAnimationPosition: null,
      fadeoutAnimationProcessing: !1,
      transformationSet: [],
      transition: Utils.getTransitionProperty(),
      translate3d: 0,
      stageWidth: 0,
      stageContentWidth: 0,
      swipeLimitMin: 0,
      swipeLimitMax: 0,
      swipeAllowedPositionMax: 0,
      swipeShiftValue: 0
    }, o.isHovered = !1, o.isAnimationDisabled = !1, o.isTouchMoveProcessStarted = !1, o.cancelTouchAnimations = !1, o.hasUserAction = !1, o.RootElement = void 0, o.rootComponentDimensions = {}, o.stageComponent = void 0, o.startTouchmovePosition = void 0, o.slideTo = o.slideTo.bind(o), o.slidePrev = o.slidePrev.bind(o), o.slideNext = o.slideNext.bind(o), o._handleTouchmove = o._handleTouchmove.bind(o), o._handleTouchend = o._handleTouchend.bind(o), o._handleDotClick = o._handleDotClick.bind(o), o._handleResize = o._handleResize.bind(o), o._handleResizeDebounced = Utils.debounce(o._handleResize, 100), o;
  }

  return __extends(t, i), t.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return [4, this._setInitialState()];

          case 1:
            return t.sent(), this._setupSwipeHandlers(), this.props.autoPlay && this._handlePlay(), window.addEventListener("resize", this._handleResizeDebounced), [2];
        }
      });
    });
  }, t.prototype.componentDidUpdate = function (t, e) {
    var i = this.props,
        n = i.activeIndex,
        o = i.animationDuration,
        s = i.autoWidth,
        a = i.children,
        r = i.infinite,
        l = i.items,
        u = i.paddingLeft,
        d = i.paddingRight,
        c = i.responsive,
        h = i.swipeExtraPadding,
        p = i.mouseTracking,
        m = i.swipeDelta,
        _ = i.touchTracking,
        i = i.touchMoveDefaultEvents;
    a && t.children !== a ? (e = e.activeIndex, e = _assign(_assign({}, this.props), {
      activeIndex: e
    }), this._updateComponent(e)) : t.autoWidth !== s || t.infinite !== r || t.items !== l || t.paddingLeft !== u || t.paddingRight !== d || t.responsive !== c || t.swipeExtraPadding !== h ? this._updateComponent() : (t.animationDuration !== o && this.setState({
      animationDuration: o
    }), t.activeIndex !== n && this.slideTo(n)), t.swipeDelta === m && t.mouseTracking === p && t.touchTracking === _ && t.touchMoveDefaultEvents === i || this._updateSwipeProps();
  }, t.prototype.componentWillUnmount = function () {
    this._cancelTimeoutAnimations(), this.swipeListener && this.swipeListener.destroy(), window.removeEventListener("resize", this._handleResizeDebounced);
  }, Object.defineProperty(t.prototype, "eventObject", {
    get: function get() {
      var t = this.state,
          e = t.itemsInSlide,
          i = t.activeIndex,
          n = Utils.getSlideItemInfo(this.state),
          t = n.isNextSlideDisabled,
          n = n.isPrevSlideDisabled;
      return {
        item: i,
        slide: Utils.getActiveSlideIndex(t, this.state),
        itemsInSlide: e,
        isNextSlideDisabled: t,
        isPrevSlideDisabled: n
      };
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "isFadeoutAnimationAllowed", {
    get: function get() {
      var t = this.state.itemsInSlide,
          e = this.props,
          i = e.animationType,
          n = e.paddingLeft,
          o = e.paddingRight,
          s = e.autoWidth,
          e = e.autoHeight;
      return 1 === t && i === types_1.AnimationType.FADEOUT && !(n || o || s || e);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "touchmovePosition", {
    get: function get() {
      return void 0 !== this.startTouchmovePosition ? this.startTouchmovePosition : this.state.translate3d;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.slideTo = function (t) {
    var e, i;
    void 0 === t && (t = 0), this._handlePause(), this.isFadeoutAnimationAllowed ? (e = Utils.getFadeoutAnimationPosition(t, this.state), i = Utils.getFadeoutAnimationIndex(this.state), this._handleSlideTo({
      activeIndex: t,
      fadeoutAnimationIndex: i,
      fadeoutAnimationPosition: e
    })) : this._handleSlideTo({
      activeIndex: t
    });
  }, t.prototype.slidePrev = function (t) {
    this._handlePause(), t && t.isTrusted && (this.hasUserAction = !0);
    var e,
        i = this.state.activeIndex - 1;
    this.isFadeoutAnimationAllowed ? (e = -this.state.stageWidth, t = Utils.getFadeoutAnimationIndex(this.state), this._handleSlideTo({
      activeIndex: i,
      fadeoutAnimationIndex: t,
      fadeoutAnimationPosition: e
    })) : this._handleSlideTo({
      activeIndex: i
    });
  }, t.prototype.slideNext = function (t) {
    this._handlePause(), t && t.isTrusted && (this.hasUserAction = !0);
    var e,
        i = this.state.activeIndex + 1;
    this.isFadeoutAnimationAllowed ? (e = this.state.stageWidth, t = Utils.getFadeoutAnimationIndex(this.state), this._handleSlideTo({
      activeIndex: i,
      fadeoutAnimationIndex: t,
      fadeoutAnimationPosition: e
    })) : this._handleSlideTo({
      activeIndex: i
    });
  }, t.prototype._handleResize = function (o) {
    return __awaiter(this, void 0, void 0, function () {
      var e, i, n;
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return (i = this.props.onResizeEvent, n = Utils.getElementDimensions(this.RootElement), (i || Utils.shouldHandleResizeEvent)(o, this.rootComponentDimensions, n)) ? (this._cancelTimeoutAnimations(), this.rootComponentDimensions = n, i = this.state, n = i.itemsCount, e = i.isAutoPlaying, i = Utils.getUpdateSlidePositionIndex(this.state.activeIndex, n), n = Utils.calculateInitialState(_assign(_assign({}, this.props), {
              activeIndex: i
            }), this.stageComponent), i = Utils.getTranslate3dProperty(n.activeIndex, n), n = _assign(_assign({}, n), {
              translate3d: i,
              isAutoPlaying: e
            }), Utils.animate(this.stageComponent, {
              position: -i
            }), [4, this.setState(n)]) : [3, 2];

          case 1:
            t.sent(), this._handleResized(), this.isAnimationDisabled = !1, e && this._handlePlay(), t.label = 2;

          case 2:
            return [2];
        }
      });
    });
  }, t.prototype._handleTouchmove = function (t, e) {
    var i = e.absY,
        n = e.absX,
        o = e.deltaX,
        s = this.props.swipeDelta,
        a = this.state,
        r = a.swipeShiftValue,
        l = a.swipeLimitMin,
        u = a.swipeLimitMax,
        e = a.infinite,
        a = a.fadeoutAnimationProcessing;

    if (this.hasUserAction = !0, !(a || !this.isTouchMoveProcessStarted && Utils.isVerticalTouchmoveDetected(n, i, s))) {
      this.isTouchMoveProcessStarted || (this._cancelTimeoutAnimations(), this._setTouchmovePosition(), this.isAnimationDisabled = !0, this.isTouchMoveProcessStarted = !0);
      var d = Utils.getTouchmoveTranslatePosition(o, this.touchmovePosition);
      if (!1 === e) return l < d || d < -u ? void 0 : void Utils.animate(this.stageComponent, {
        position: d
      });
      if (Utils.shouldRecalculateSwipePosition(d, l, u)) try {
        !function t() {
          Utils.getIsLeftDirection(o) ? d += r : d += -r;
          Utils.shouldRecalculateSwipePosition(d, l, u) && t();
        }();
      } catch (t) {
        Utils.debug(t);
      }
      Utils.animate(this.stageComponent, {
        position: d
      });
    }
  }, t.prototype._handleTouchend = function (t, e) {
    var i,
        n,
        o = e.deltaX;
    this._clearTouchmovePosition(), this.isTouchMoveProcessStarted && (this.isTouchMoveProcessStarted = !1, i = this.state.animationDuration, n = this.props.animationEasingFunction, e = Utils.getTranslateXProperty(this.stageComponent), e = Utils.getSwipeTouchendPosition(this.state, o, e), this._handleSlideChange(), Utils.animate(this.stageComponent, {
      position: e,
      animationDuration: i,
      animationEasingFunction: n
    }), this._handleBeforeTouchEnd(e));
  }, t.prototype._handleBeforeTouchEnd = function (o) {
    var t = this,
        e = this.state.animationDuration;
    this.touchEndTimeoutId = setTimeout(function () {
      return __awaiter(t, void 0, void 0, function () {
        var e, i, n;
        return __generator(this, function (t) {
          switch (t.label) {
            case 0:
              return e = Utils.getSwipeTouchendIndex(o, this.state), i = Utils.getTranslate3dProperty(e, this.state), Utils.animate(this.stageComponent, {
                position: -i
              }), n = Utils.getTransitionProperty(), [4, this.setState({
                activeIndex: e,
                translate3d: i,
                transition: n
              })];

            case 1:
              return t.sent(), [4, this._handleSlideChanged()];

            case 2:
              return t.sent(), [2];
          }
        });
      });
    }, e);
  }, t.prototype._handleSlideTo = function (t) {
    var e = t.activeIndex,
        a = void 0 === e ? 0 : e,
        e = t.fadeoutAnimationIndex,
        r = void 0 === e ? null : e,
        t = t.fadeoutAnimationPosition,
        l = void 0 === t ? null : t;
    return __awaiter(this, void 0, void 0, function () {
      var e, i, n, o, s;
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return (o = this.props, e = o.infinite, n = o.animationEasingFunction, i = this.state, s = i.itemsInSlide, o = i.itemsCount, i = i.animationDuration, this.isAnimationDisabled || this.state.activeIndex === a || !e && Utils.shouldCancelSlideAnimation(a, o, s)) ? [2] : (this.isAnimationDisabled = !0, this._cancelTimeoutAnimations(), this._handleSlideChange(), o = !1, s = Utils.getTranslate3dProperty(a, this.state), n = null !== r && null !== l ? (o = !0, Utils.getTransitionProperty()) : Utils.getTransitionProperty({
              animationDuration: i,
              animationEasingFunction: n
            }), [4, this.setState({
              activeIndex: a,
              transition: n,
              translate3d: s,
              animationDuration: i,
              fadeoutAnimationIndex: r,
              fadeoutAnimationPosition: l,
              fadeoutAnimationProcessing: o
            })]);

          case 1:
            return t.sent(), this.slideEndTimeoutId = setTimeout(this._handleBeforeSlideEnd, i), [2];
        }
      });
    });
  }, t.prototype._handleUpdateSlidePosition = function (o) {
    return __awaiter(this, void 0, void 0, function () {
      var e, i, n;
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return e = this.state.animationDuration, i = Utils.getTranslate3dProperty(o, this.state), n = Utils.getTransitionProperty({
              animationDuration: 0
            }), [4, this.setState({
              activeIndex: o,
              translate3d: i,
              transition: n,
              animationDuration: e,
              fadeoutAnimationIndex: null,
              fadeoutAnimationPosition: null,
              fadeoutAnimationProcessing: !1
            })];

          case 1:
            return t.sent(), [2];
        }
      });
    });
  }, t.prototype._handleSlideChange = function () {
    this.props.onSlideChange && this.props.onSlideChange(this.eventObject);
  }, t.prototype._handleResized = function () {
    this.props.onResized && this.props.onResized(this.eventObject);
  }, t.prototype._handleSlideChanged = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e, i, n, o;
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return n = this.state, e = n.isAutoPlaying, i = n.isAutoPlayCanceledOnAction, o = this.props, n = o.autoPlayStrategy, o = o.onSlideChanged, Utils.shouldCancelAutoPlayOnAction(n) && this.hasUserAction && !i ? [4, this.setState({
              isAutoPlayCanceledOnAction: !0,
              isAutoPlaying: !1
            })] : [3, 2];

          case 1:
            return t.sent(), [3, 3];

          case 2:
            e && this._handlePlay(), t.label = 3;

          case 3:
            return this.isAnimationDisabled = !1, o && o(this.eventObject), [2];
        }
      });
    });
  }, t.prototype._handleDotClick = function (t) {
    this.hasUserAction = !0, this.slideTo(t);
  }, t.prototype._handlePlay = function () {
    this._setAutoPlayInterval();
  }, t.prototype._cancelTimeoutAnimations = function () {
    this._clearAutoPlayTimeout(), this._clearSlideEndTimeout(), this.clearTouchendTimeout();
  }, t.prototype._clearAutoPlayTimeout = function () {
    clearTimeout(this.autoPlayTimeoutId), this.autoPlayTimeoutId = void 0;
  }, t.prototype._clearSlideEndTimeout = function () {
    clearTimeout(this.slideEndTimeoutId), this.slideEndTimeoutId = void 0;
  }, t.prototype.clearTouchendTimeout = function () {
    clearTimeout(this.touchEndTimeoutId), this.touchEndTimeoutId = void 0;
  }, t.prototype._clearTouchmovePosition = function () {
    this.startTouchmovePosition = void 0;
  }, t.prototype._setTouchmovePosition = function () {
    var t = Utils.getTranslateXProperty(this.stageComponent);
    this.startTouchmovePosition = -t;
  }, t.prototype._setInitialState = function () {
    return __awaiter(this, void 0, void 0, function () {
      var e;
      return __generator(this, function (t) {
        switch (t.label) {
          case 0:
            return e = Utils.calculateInitialState(this.props, this.stageComponent), this.rootComponentDimensions = Utils.getElementDimensions(this.RootElement), [4, this.setState(e)];

          case 1:
            return t.sent(), this.props.onInitialized && this.props.onInitialized(this.eventObject), [2];
        }
      });
    });
  }, t.prototype._setAutoPlayInterval = function () {
    var t = this,
        e = this.props,
        i = e.autoPlayDirection,
        e = e.autoPlayInterval;
    this.autoPlayTimeoutId = setTimeout(function () {
      t.isHovered || (i === types_1.AutoplayDirection.RTL ? t.slidePrev({}) : t.slideNext({}));
    }, e);
  }, t.prototype._setupSwipeHandlers = function () {
    this.swipeListener = new vanilla_swipe_1.default({
      element: this.RootElement,
      delta: this.props.swipeDelta,
      onSwiping: this._handleTouchmove,
      onSwiped: this._handleTouchend,
      rotationAngle: 5,
      mouseTrackingEnabled: this.props.mouseTracking,
      touchTrackingEnabled: this.props.touchTracking,
      preventDefaultTouchmoveEvent: !this.props.touchMoveDefaultEvents,
      preventTrackingOnMouseleave: !0
    }), this.swipeListener.init();
  }, t.prototype._updateComponent = function (t) {
    var e = this;
    void 0 === t && (t = this.props), this._cancelTimeoutAnimations(), this.isAnimationDisabled = !1, this.state.isAutoPlaying && this._handlePlay(), this.setState({
      clones: Utils.createClones(t)
    }), requestAnimationFrame(function () {
      e.setState(Utils.calculateInitialState(t, e.stageComponent));
    });
  }, t.prototype._updateSwipeProps = function () {
    this.swipeListener && this.swipeListener.update({
      delta: this.props.swipeDelta,
      mouseTrackingEnabled: this.props.mouseTracking,
      touchTrackingEnabled: this.props.touchTracking,
      preventDefaultTouchmoveEvent: !this.props.touchMoveDefaultEvents
    });
  }, t.prototype._renderDotsNavigation = function () {
    var t = this.props.renderDotsItem;
    return react_1.default.createElement(Views.DotsNavigation, {
      state: this.state,
      onClick: this._handleDotClick,
      renderDotsItem: t
    });
  }, t.prototype._renderPrevButton = function () {
    var t = this.props.renderPrevButton,
        e = Utils.getSlideItemInfo(this.state).isPrevSlideDisabled;
    return react_1.default.createElement(Views.PrevNextButton, {
      name: "prev",
      onClick: this.slidePrev,
      isDisabled: e,
      renderPrevButton: t
    });
  }, t.prototype._renderNextButton = function () {
    var t = this.props.renderNextButton,
        e = Utils.getSlideItemInfo(this.state).isNextSlideDisabled;
    return react_1.default.createElement(Views.PrevNextButton, {
      name: "next",
      onClick: this.slideNext,
      isDisabled: e,
      renderNextButton: t
    });
  }, t.prototype._renderPlayPauseButton = function () {
    var t = this.props.renderPlayPauseButton,
        e = this.state.isAutoPlaying;
    return react_1.default.createElement(Views.PlayPauseButton, {
      isPlaying: e,
      onClick: this._handlePlayPauseToggle,
      renderPlayPauseButton: t
    });
  }, t.prototype.render = function () {
    var t = this.state,
        e = t.translate3d,
        i = t.clones,
        n = t.transition,
        o = Utils.shouldDisableDots(this.props, this.state),
        t = Utils.getRenderWrapperStyles(this.props, this.state, this.stageComponent),
        n = Utils.getRenderStageStyles({
      translate3d: e
    }, {
      transition: n
    });
    return react_1.default.createElement("div", {
      className: "alice-carousel"
    }, react_1.default.createElement("div", {
      ref: this._setRootComponentRef
    }, react_1.default.createElement("div", {
      style: t,
      className: "alice-carousel__wrapper",
      onMouseEnter: this._handleMouseEnter,
      onMouseLeave: this._handleMouseLeave
    }, react_1.default.createElement("ul", {
      style: n,
      className: "alice-carousel__stage",
      ref: this._setStageComponentRef
    }, i.map(this._renderStageItem)))), o ? null : this._renderDotsNavigation(), this.props.disableSlideInfo ? null : this._renderSlideInfo(), this.props.disableButtonsControls ? null : this._renderPrevButton(), this.props.disableButtonsControls ? null : this._renderNextButton(), this.props.autoPlayControls ? this._renderPlayPauseButton() : null);
  }, t.defaultProps = defaultProps_1.defaultProps, t;
}(react_1.default.PureComponent);

exports.default = AliceCarousel;